<template>
  <!-- 表格 -->
  <a-table
    :loading="loading"
    class="table"
    :rowKey="(record, index) => index"
    :columns="columns"
    :data-source="tableData"
    :transformCellText="({ text }) => text ?? '--'"
    :scroll="{
      x: '100%',
      y: 'calc(68vh)'
    }"
    :pagination="false"
  >
    <!--    身份标签-->
    <!--    健管-->
    <template #operatorName="{ text }">
      <roles :solerType="4" />
      <span>{{ text }}</span>
    </template>
    <!--    患者-->
    <template #patientName="{ text }">
      <roles :solerType="1" />
      <PatientNameAgeReveal :name="text" />
    </template>
    <!--    医生-->
    <template #doctorName="{ text }">
      <roles :solerType="2" />
      <span>{{ text }}</span>
    </template>
    <!--    处方、预病例、复诊操作项-->
    <template #handle="data">
      <a-button class="button-link" type="link" @click="props.openModal(data)">
        {{ btnTextMap[props.type] }}
      </a-button>
    </template>
    <!--   随访操作项-->
    <template #handleVisit="data">
      <a-button
        v-if="data.record.followupType === 2"
        class="button-link"
        type="link"
        @click="props.openModal(data)"
      >
        {{ btnTextMap[props.type] }}
      </a-button>
      <a-button class="button-link" type="link" v-else>
        {{ '-' }}
      </a-button>
    </template>
    <!--    平台操作项-->
    <template #platformOption="data">
      <a-button
        class="button-link"
        type="link"
        @click="props.openModal(data)"
        v-if="data.record.hasAction"
      >
        {{ data.record.platformType === 3 ? '标记为已关闭' : '标记为已置顶' }}
      </a-button>
      <a-button class="button-link" type="link" v-else>
        {{ '-' }}
      </a-button>
    </template>
  </a-table>
</template>

<script setup>
import { ref, defineProps, onMounted, computed, defineExpose } from 'vue'
import { btnTextMap, todoModalTab } from '@/components/PatientFile/ModalBody/todo/config'
import { useStore } from 'vuex'
import { getSummaryTodo } from '@/api/patientFile'
import PatientNameAgeReveal from '@/components/PatientNameAgeReveal.vue'

const store = useStore()

const props = defineProps({
  columns: {
    type: Object,
    default: () => ({}),
    required: true
  },
  openModal: {
    type: null,
    default: () => {}
  },
  type: {
    type: String,
    default: ''
  }
})
const columns = ref(props.columns)
const loading = ref(false)
const tableData = ref([])
const info = computed(() => store.state.patientFile.info)

const getTodoData = params => {
  loading.value = true
  getSummaryTodo(params)
    .then(res => {
      console.log('_++_', { res })
      const type = todoModalTab.filter(item => item.ref === props.type)[0].list
      tableData.value = res[type]
      // 数据加载完成后，通知父组件更新数量
      store.dispatch('patientFile/updateTodoNum', {
        type: props.type,
        count: tableData.value.length
      })
    })
    .finally(() => {
      loading.value = false
    })
}

// 组件首次加载时获取数据
onMounted(() => {
  const type = todoModalTab.filter(item => item.ref === props.type)[0].key
  getTodoData({
    type,
    ucPatientId: info.value.ucPatientId
  })
})

// 暴露刷新方法给父组件
defineExpose({
  refreshTable: () => {
    const type = todoModalTab.filter(item => item.ref === props.type)[0].key
    getTodoData({
      type,
      ucPatientId: info.value.ucPatientId
    })
  }
})
</script>

<style lang="scss" scoped>
:deep(.button-link) {
  padding: 0 !important;
}
</style>
